// YouTube Iframe API
const tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
tag.classList.add('js-iframe-api');
const firstScriptTag = document.getElementsByTagName('script')[0];

// If the YouTube Iframe API <script> doesnt exist
const iframeAPI = document.querySelector('.js-iframe-api');

if (!iframeAPI) {
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

/**
* Youtube API for Video Swiper
*/
// Init a custom YouTube player through its API if we have a video
const initPlayer = function (element, state) {
  if (typeof YT == 'undefined') return;

  if (state === 'background') {

    const iframe = element.querySelector('.js-iframe-player');
    const bgVideoID = element.dataset.video;
    let ytPlayer;

    // Set the player options
    const playerOptions = {
      autoplay: 0,
      mute: 1,
      autohide: 1,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      controls: 0,
      disablekb: 1,
      enablejsapi: 1,
      iv_load_policy: 3,
      // For looping video you have to have loop to 1
      // And playlist value equal to your currently playing video
      loop: 1,
      playlist: bgVideoID
    }

    if (element.classList.contains('header__video')){
      playerOptions.autoplay = 1;
    }

    ytPlayer = new YT.Player(iframe, {
      width: '1920',
      height: '1080',
      videoId: bgVideoID,
      playerVars: playerOptions,
      events: {
        'onReady': onIframePlayerReady,
        'onStateChange': onIframePlayerStateChange
      }
    });

  } else if (state === 'single') {
    const playerIframe = element.querySelector('.responsive-video__target');
    const playerOverlay = element.querySelector('.responsive-video__overlay');

    playerOverlay.classList.add('hide');

    // Set the player options
    const playerOptions = {
      autoplay: 0,
      mute: 0,
      autohide: 1,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      controls: 2,
      disablekb: 1,
      enablejsapi: 1,
      iv_load_policy: 3,
    };

    new YT.Player(playerIframe, {
      width: '1280',
      height: '720',
      playerVars: playerOptions,
      videoId: element.dataset.videoid,
    });
  } else {
    const player = element.querySelector('.video-iframe');
    const button = element.querySelector('.video-play');

    const ytvideo = new YT.Player(player, {
      playerVars: {
        autoplay: 0,
        modestbranding: 1,
        controls: 2,
        rel: 0,
      },
      videoId: element.dataset.videoid
    });

    // Custom play/pause button (overlay on the video)
    button.addEventListener('click', function () {
      switch (ytvideo.getPlayerState()) {
      case 1:
        ytvideo.pauseVideo();
        break;
      default:
        ytvideo.playVideo();
        break;
      }
    });
  }
}

// 4. The API will call this function when the video player is ready.
function onIframePlayerReady(event) {

  // Get the duration of the currently playing video
  const videoDuration = event.target.getDuration();

  // When the video is playing, compare the total duration
  // To the current passed time if it's below 2 and above 0,
  // Return to the first frame (0) of the video
  // This is needed to avoid the buffering at the end of the video
  // Which displays a black screen + the YouTube loader
  setInterval(function (){
    const videoCurrentTime = event.target.getCurrentTime();
    const timeDifference = videoDuration - videoCurrentTime;

    if (2 > timeDifference > 0) {
      event.target.seekTo(0);
    }
  }, 1000);
}

// When the player is ready and when the video starts playing
// The state changes to PLAYING and we can remove our overlay
// This is needed to mask the preloading
function onIframePlayerStateChange(event) {
  // Get the video overlay, to mask it when the video is loaded
  const videoOverlay = document.querySelector('.js-video-overlay');

  if (videoOverlay && event.data == YT.PlayerState.PLAYING) {
    videoOverlay.classList.add('header__video__overlay--fadeOut');
  } else if (videoOverlay && event.data == YT.PlayerState.PAUSED) {
    videoOverlay.classList.remove('header__video__overlay--fadeOut');
  }
}


// Destroys player
const destroyPlayer = function (player) {
  const playerId = player.querySelector('.youtube-player__target').id;
  const playerOverlay = player.querySelector('.youtube-player__overlay');

  playerOverlay.classList.remove('hide');

  if (playerId) {
    YT.get(playerId).destroy();
  }
};

// When YouTube API is ready, init the custom player
window.onYouTubePlayerAPIReady = function () {
  const container = document.querySelectorAll('.video-container');
  const singleVideos = document.querySelectorAll('.js-youtube-player');
  const bgVideos = document.querySelectorAll('.js-background-video');

  if (container.length) {
    for (let i = 0; i < container.length; i++) {
      initPlayer(container[i]);
    }
  }

  if (singleVideos.length) {
    for (let i = 0; i < singleVideos.length; i++) {
      const singleVideo = singleVideos[i];

      // comment after testing
      // document.querySelectorAll('.js-youtube-cookie').forEach((buttonConsent) => {
      //   buttonConsent.addEventListener('click', (e) => {
      //     initPlayer(singleVideo, 'single');
      //     e.preventDefault();
      //   });
      // });

      // Uncomment after testing
      // Axeptio SDK
      window._axcb = window._axcb || [];
      window._axcb.push(function (sdk) {
        sdk.on('cookies:complete', function (choices) {
          if (choices.youtube) {
            initPlayer(singleVideo, 'single');
          } else {
            destroyPlayer(singleVideo);
          }
        });

        // Axeptio custom consent request
        document.querySelectorAll('.js-youtube-cookie').forEach((buttonConsent) => {
          buttonConsent.addEventListener('click', () =>
            sdk.requestConsent('youtube')
          );
        });
      });
    }
  }

  if (bgVideos.length) {
    bgVideos.forEach((bgVideo) => {
      initPlayer(bgVideo, 'background');
    })
  }
}

